import { render, staticRenderFns } from "./AdminSettingsSetupChecks.vue?vue&type=template&id=049e764c"
import script from "./AdminSettingsSetupChecks.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSettingsSetupChecks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdminSettingsSetupChecks.vue?vue&type=style&index=0&id=049e764c&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports